import { useTranslation } from 'react-i18next';

import { Card, Flex, Layout, Spin, theme, Typography } from 'antd';

import { useMedia } from 'shared/hooks';

const { Title, Paragraph } = Typography;
const { Header } = Layout;

export const AppLoadingPage = () => {
	const { t } = useTranslation();
	const isMobile = useMedia();
	const {
		token: { fontSizeLG },
	} = theme.useToken();

	return (
		<Layout style={{ height: '100vh' }}>
			<Header style={{ backgroundColor: 'rgba(255, 255, 255, 1)', height: 60 }} />
			<Flex style={{ margin: isMobile ? 24 : 16, height: '100%' }}>
				<Card
					style={{ width: '100%', height: '100%', maxHeight: 600, textAlign: 'center' }}
					styles={{
						body: {
							display: 'flex',
							height: '100%',
							justifyContent: 'center',
							alignItems: 'center',
							flexDirection: 'column',
						},
					}}>
					<Spin size="large" />
					<Title level={4}>{t('Loading the best offers - especially for you!')}</Title>
					<Paragraph style={{ fontSize: fontSizeLG }}>{t("Don't leave, it will be interesting 🫶")}</Paragraph>
				</Card>
			</Flex>
		</Layout>
	);
};
